import { Box, Checkbox, FormControl, FormControlLabel } from '@mui/material';
import InfoTooltip from 'app/common/components/info-tooltip';
import Widget from 'app/common/components/widgets/widget';
import type { InputHTMLAttributes } from 'react';
import type { BooleanWidgetHookProps } from './boolean-widget-hook';

export function BooleanInput({
  label,
  error,
  checked,
  disabled,
  readOnly,
  handleChange,
  description,
  id
}: BooleanWidgetHookProps) {
  const labelWithDescription = description ? (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        flexDirection: 'row',
        gap: 1
      }}
    >
      <Box>{label}</Box>
      <InfoTooltip text={description} />
    </Box>
  ) : (
    <Box>{label}</Box>
  );

  return (
    <FormControl error={Boolean(error)}>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={handleChange}
            inputProps={
              // Types are messed up for these input props
              {
                'data-testid': `${id}__checkbox`
              } as InputHTMLAttributes<HTMLInputElement> & Record<string, string>
            }
          />
        }
        label={labelWithDescription}
        disabled={Boolean(disabled) || Boolean(readOnly)}
      />
    </FormControl>
  );
}

export function BooleanWidget(props: BooleanWidgetHookProps) {
  return (
    <Widget testId={props.id}>
      <BooleanInput {...props} />
    </Widget>
  );
}
